import api from '../../services/api';

const returnToNotStarted = async (requestId) =>
    api.patch({ type: 'user', service: `requests/${requestId}/return-to-not-started` });

export default {
    returnToNotStarted,
}
